import gameTitleImage from "app/assets/title-image.png";
import useGameData from "app/game-data/useGameData";
import useGameState from "app/game/useGameState";
import ExitGameButton from "app/top-nav/ExitGameButton";
import MenuButton from "app/ui/MenuButton";
import cn from "app/util/classnames";
import { formatPublishDate } from "app/util/timeUtils";
import mixpanel from "mixpanel-browser";

interface TitleScreenProps {
  onDismiss: () => void;
}

export default function TitleScreen(props: TitleScreenProps) {
  const data = useGameData();
  const constructorName = data?.level?.constructorName ?? "Word Puzzleman";
  const publishDate = data?.publishDate ?? "1988-07-28";
  const { boardState } = useGameState();

  return (
    <div className="w-full h-full flex flex-col bg-green-mid">
      <ExitGameButton alwaysShowText={true} />
      <div
        className={cn(
          "flex-1 min-h-0 overflow-auto",
          "flex flex-col items-center justify-start gap-5",
          "mx-auto py-5",
        )}
      >
        <img
          src={gameTitleImage}
          className="aspect-square w-200 max-w-75 md:max-w-[50%] h-auto min-h-40 max-h-[50dvh] object-contain"
          alt=""
          width={630}
          height={630}
          onLoad={() => {
            mixpanel.track_pageview({
              page: `Game Title Screen`,
              game_id: data?.id,
            });
          }}
        />
        <h1
          className={cn(
            "text-center text-5xl md:text-6xl",
            "font-condensed leading-none -tracking-[0.02em] uppercase",
          )}
        >
          Pixellence
        </h1>
        <p className="max-w-md px-2 text-center text-lg font-bold uppercase leading-[1.38] tracking-[0.03em]">
          Where logic meets art.
        </p>
        {publishDate && (
          <>
            <MenuButton // Play button
              className="max-w-55 w-55 h-13"
              onClick={() => {
                props.onDismiss();
              }}
            >
              {boardState !== "[]" ? "Resume" : "Play Now"}
            </MenuButton>
            <p className="text-center text-sm tracking-[-0.015em] lg:text-base font-medium font-sans">
              {`By ${constructorName} - ${formatPublishDate(publishDate)}`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}